import React from "react";
import { TableColumnsItem } from "../../interfaces/components/mainTable";
import { ColumnType, ButtonType } from "../utils/enums";
import { InsuranceCompany } from "../../interfaces/screens/billing";
import { Edit, Trash } from "lucide-react";

interface InsurerColumnHandlers {
  onEdit: (insurer: InsuranceCompany) => void;
  onDelete: (insurer: InsuranceCompany) => void;
}

export const getInsurersTableColumns = (
  handlers: InsurerColumnHandlers,
): TableColumnsItem[] => [
  { key: "name", name: "Name", type: ColumnType.TEXT },
  {
    key: "insurer_type",
    name: "Type",
    type: ColumnType.CUSTOM,
    customValue: (row: InsuranceCompany) => {
      const typeLabels: Record<string, string> = {
        nssf: "NSSF",
        moph: "MOPH",
        private: "Private",
        cooperative: "Cooperative",
        corporate: "Corporate",
      };
      return typeLabels[row.insurer_type] || row.insurer_type;
    },
  },
  { key: "contact_person", name: "Contact Person", type: ColumnType.TEXT },
  { key: "phone_number", name: "Phone", type: ColumnType.TEXT },
  { key: "email", name: "Email", type: ColumnType.TEXT },
  {
    key: "processing_time_days",
    name: "Processing Time",
    type: ColumnType.CUSTOM,
    customValue: (row: InsuranceCompany) =>
      row.processing_time_days ? `${row.processing_time_days} days` : "N/A",
  },
  {
    key: "submission_type",
    name: "Submission",
    type: ColumnType.CUSTOM,
    customValue: (row: InsuranceCompany) => {
      if (row.requires_paper_submission && row.accepts_electronic_submission) {
        return "Both";
      } else if (row.requires_paper_submission) {
        return "Paper Only";
      } else if (row.accepts_electronic_submission) {
        return "Electronic Only";
      }
      return "N/A";
    },
  },
  {
    key: "actions",
    name: "Actions",
    type: ColumnType.BUTTON,
    buttonsList: [
      {
        type: ButtonType.ICON,
        icon: Edit,
        onPress: (e: React.MouseEvent, row: InsuranceCompany) =>
          handlers.onEdit(row),
      },
      {
        type: ButtonType.ICON,
        icon: Trash,
        cssClass: "delete",
        onPress: (e: React.MouseEvent, row: InsuranceCompany) =>
          handlers.onDelete(row),
      },
    ],
  },
];
